const URL = process.env.REACT_APP_URL;

export const timeData = [
  "7:00 AM",
  "7:30 AM",
  "8:00 AM",
  "8:30 AM",
  "9:00 AM",
  "9:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "1:00 PM",
  "1:30 PM",
  "2:00 PM",
  "2:30 PM",
  "3:00 PM",
  "3:30 PM",
  "4:00 PM",
  "4:30 PM",
  "5:00 PM",
  "5:30 PM",
  "6:00 PM",
];

const closed_listing_conditions = [
  {
    value: "very_poor",
    label: "Very Poor",
    helperText:
      "Select this option if this home is substandard to the rest of the neighborhood",
  },
  {
    value: "poor",
    label: "Poor",
    helperText:
      "Select this option if this home is slightly substandard to the rest of the neighborhood",
  },
  {
    value: "average",
    label: "Average",
    helperText:
      "Select this option if this home is  standard to the rest of the neighborhood",
  },
  {
    value: "above_average",
    label: "Above Average",
    helperText:
      "Select this option if this home is slightly above standard to the rest of the neighborhood",
  },
  {
    value: "excellent",
    label: "Excellent",
    helperText:
      "Select this option if this home is greatly above standard to the rest of the neighborhood",
  },
];

const resources = {
  headerTitle: "Resources",
  route: "",
  option: [
    {
      text: "Buyer's checklist",
      route: "",
    },
    {
      text: "Resource center",
      route: "",
    },
    {
      text: "First timer",
      route: "",
    },
    {
      text: "Housing market",
      route: "",
    },
  ],
};

export const choices = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this_week", label: "This Week" },
  { value: "last_week", label: "Last Week" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "this_quarter", label: "This Quarter" },
  { value: "last_quarter", label: "Last Quarter" },
  { value: "this_year", label: "This Year" },
  { value: "last_year", label: "Last Year" },
];

export const propertyList = {
  roof: "Tile",
  cooling: null,
  style: "Traditional",
  area: 1043,
  bathsFull: 5,
  bathsHalf: 6,
  stories: 3,
  fireplaces: 1,
  flooring: null,
  heating: "Radiant Heat",
  bathrooms: null,
  foundation: "Slab",
  laundryFeatures: "Area,Electric Dryer Hookup,Individual Room,Washer Hookup",
  occupantName: null,
  ownerName: null,
  lotDescription: "Private Backyard",
  pool: "Association,Private,In Ground",
  subType: null,
  bedrooms: 2,
  interiorFeatures:
    "Drapes/Curtains/Window Cover, Fire/Smoke Alarm, High Ceiling, Island Kitchen",
  lotSize: "127X146",
  areaSource: "Floorplans",
  maintenanceExpense: null,
  additionalRooms: "Recreation,Master Bedroom,See Remarks",
  exteriorFeatures: "Back Yard Fenced, Covered Patio/Deck, Patio/Deck",
  water: null,
  view: "Golf Course",
  lotSizeArea: null,
  subdivision: "Waterstone Springs",
  construction: "In Kitchen,Stackable,Washer Included",
  lotSizeAreaUnits: null,
  type: "RES",
  garageSpaces: 8.74556425245327,
  bathsThreeQuarter: null,
  accessibility: "Manned Gate",
  acres: null,
  occupantType: null,
  subTypeText: null,
  yearBuilt: 1998,
};

export const quesLists = [
  [
    {
      title: "When do you plan on selling?",
      subTitle: "Please tell us your ideal timeline for closing the sale.",
      options: [
        "ASAP",
        "6 - 12 months",
        "1 - 3 months",
        "12+ months",
        "3 - 6 months",
      ],
      formID: "sellingPlan",
    },
  ],
  [
    {
      title: "What is the current condition of your home?",
      subTitle: "Please select an answer",
      options: ["Needs Significant work", "Needs a little work", "Tear down"],
      formID: "currentCondition",
    },
  ],
  [
    {
      title: "Why are you selling your home?",
      subTitle: "Please select an answer",
      options: [
        "Upgrading my home",
        "Downsizing my home",
        "Selling secondary home",
        "Retiring",
        "Relocating",
        "Other",
      ],
      formID: "whySell",
    },
  ],
  [
    {
      title: "Are you currently working with a real estate agent? ",
      subTitle: "Please select an answer",
      options: ["Yes", "No"],
      formID: "haveAnAgent",
    },
  ],
  [
    {
      title: "Are you also looking to buy a home?",
      subTitle: "Please select an answer",
      options: ["Yes", "No"],
      formID: "wantToBuyAHome",
    },
  ],
  [
    {
      title: "Have you made any improvements to your home?",
      subTitle: "Please provide any improvement made",
      options: "improvementForm",
    },
  ],
  [
    {
      title: "We’ll like to know you more:",
      subTitle: "",
      options: "personalDetailsForm",
    },
  ],
];

const buyingOptions = {
  headerTitle: "Buying Options",
  route: "",
  option: [
    {
      text: "Buy with Homelytica",
      route: "",
    },
    {
      text: "Buy with a broker",
      route: "",
    },
  ],
};
/**
 * dropdown that appears when a user hovers over buy
 */
const buyList = [
  {
    headerTitle: "Home For Sale",
    route: "/buy",
    option: [
      {
        text: "Home for sale",
        route: "",
      },
      {
        text: "Foreclosure",
        route: "",
      },
      {
        text: "For sale by owner",
        route: "",
      },
      {
        text: "Open houses",
        route: "",
      },
    ],
  },
  {
    headerTitle: "",
    route: "",
    option: [
      {
        text: "New construction",
        route: "",
      },
      {
        text: "Upcoming",
        route: "",
      },
      {
        text: "Recent home sales",
        route: "",
      },
      {
        text: "All houses",
        route: "",
      },
    ],
  },
  buyingOptions,
  resources,
];

const sellList = [
  {
    headerTitle: "My Home",
    route: "/sell ",
    option: [
      {
        text: "A BPO Home Value",
        route: "",
      },
      {
        text: "My BPO Dashboard",
        route: "",
      },
    ],
  },
  {
    headerTitle: "BPO Selling Options",
    route: "/sell ",
    option: [
      {
        text: "A BPO Home Value",
        route: "",
      },
      {
        text: "My BPO Dashboard",
        route: "",
      },
    ],
  },
  resources,
];

const analyticsList = [
  {
    headerTitle: "",
    option: [
      {
        text: "Investors Deal Analyzer",
        route: "",
      },
      {
        text: "BPO",
        route: "",
      },
      {
        text: "BPO Farm",
        route: "",
      },
    ],
  },
];

const professionalOptions = [
  { value: "agent", label: "Real Estate Agent" },
  { value: "realty_agent", label: "BPO Homes Realty Agent" },
];

const statesShort = [
  {
    label: "Alaska",
    value: "AK",
  },
  {
    label: "Alabama",
    value: "AL",
  },
  {
    label: "Arkansas",
    value: "AR",
  },
  {
    label: "Arizona",
    value: "AZ",
  },
  {
    label: "California",
    value: "CA",
  },
  {
    label: "Colorado",
    value: "CO",
  },
  {
    label: "Connecticut",
    value: "CT",
  },
  {
    label: "Delaware",
    value: "DE",
  },
  {
    label: "Florida",
    value: "FL",
  },
  {
    label: "Georgia",
    value: "GA",
  },
  {
    label: "Hawaii",
    value: "HI",
  },
  {
    label: "Iowa",
    value: "IA",
  },
  {
    label: "Idaho",
    value: "ID",
  },
  {
    label: "Illinois",
    value: "IL",
  },
  {
    label: "Indiana",
    value: "IN",
  },
  {
    label: "Kansas",
    value: "KS",
  },
  {
    label: "Kentucky",
    value: "KY",
  },
  {
    label: "Louisiana",
    value: "LA",
  },
  {
    label: "Massachusetts",
    value: "MA",
  },
  {
    label: "Maryland",
    value: "MD",
  },
  {
    label: "Maine",
    value: "ME",
  },
  {
    label: "Michigan",
    value: "MI",
  },
  {
    label: "Minnesota",
    value: "MN",
  },
  {
    label: "Missouri",
    value: "MO",
  },
  {
    label: "Mississippi",
    value: "MS",
  },
  {
    label: "Montana",
    value: "MT",
  },
  {
    label: "North Carolina",
    value: "NC",
  },
  {
    label: "North Dakota",
    value: "ND",
  },
  {
    label: "Nebraska",
    value: "NE",
  },
  {
    label: "New Hampshire",
    value: "NH",
  },
  {
    label: "New Jersey",
    value: "NJ",
  },
  {
    label: "New Mexico",
    value: "NM",
  },
  {
    label: "Nevada",
    value: "NV",
  },
  {
    label: "New York",
    value: "NY",
  },
  {
    label: "Ohio",
    value: "OH",
  },
  {
    label: "Oklahoma",
    value: "OK",
  },
  {
    label: "Oregon",
    value: "OR",
  },
  {
    label: "Pennsylvania",
    value: "PA",
  },
  {
    label: "Rhode Island",
    value: "RI",
  },
  {
    label: "South Carolina",
    value: "SC",
  },
  {
    label: "South Dakota",
    value: "SD",
  },
  {
    label: "Tennessee",
    value: "TN",
  },
  {
    label: "Texas",
    value: "TX",
  },
  {
    label: "Utah",
    value: "UT",
  },
  {
    label: "Virginia",
    value: "VA",
  },
  {
    label: "Vermont",
    value: "VT",
  },
  {
    label: "Washington",
    value: "WA",
  },
  {
    label: "Wisconsin",
    value: "WI",
  },
  {
    label: "West Virginia",
    value: "WV",
  },
  {
    label: "Wyoming",
    value: "WY",
  },
];

const states = statesShort.map((item) => ({
  value: item.label,
  label: item.label,
}));

const farmPackages = [
  {
    title: "Premier Agent (SET UP FEE NOT INCLUDED $99)",
    benefits: [
      `Phone Numbers & Emails`,
      `Premier Agent Advertising`,
      `NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited`,
      `Divorce Leads Unlimited`,
      `Probate Leads Unlimited`,
      `FSBO (For Sale By Owner) Leads Unlimited`,
      `Expired Leads Unlimited`,
      `Canceled Leads Unlimited`,
      `Withdrawn Leads Unlimited`,
      `Deal Analyzer Access`,
      `Unlimited BPO Tech Training Center Access`,
      `BPO Report Ordering Page`,
      `Luxury Investor Website`,
      `Investor Log (Investor List Available for Purchase)`,
      `MDA (Million Dollar Agent) Business Program`,
      `20% Referral Fee Required from BPO Homes Pre-Qualified Leads`,
      `Basic Go High Level`,
      `Life Insurance Licensing Fee Add On`,
      `Pro Edge Not Included`,
    ],
  },
  {
    title: "Premier Agent Pro (SET UP FEE NOT INCLUDED $99)",
    benefits: [
      `Phone Numbers & Emails`,
      `Premier Agent Advertising`,
      `NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited`,
      `Divorce Leads Unlimited`,
      `Probate Leads Unlimited`,
      `FSBO (For Sale By Owner) Leads Unlimited`,
      `Expired Leads Unlimited`,
      `Canceled Leads Unlimited`,
      `Withdrawn Leads Unlimited`,
      `Deal Analyzer Access`,
      `Unlimited BPO Tech Training Center Access`,
      `BPO Report Ordering Page`,
      `Luxury Investor Website`,
      `Investor Log (Investor List Available for Purchase)`,
      `MDA (Million Dollar Agent) Business Program`,
      `20% Referral Fee Required from BPO Homes Pre-Qualified Leads`,
      `Go High Level CRM Pro Edge Included`,
      `Life Insurance Licensing Fee Add On`,
    ],
  },
  {
    title: "Premier Agent Elite (SET UP FEE NOT INCLUDED $99)",
    benefits: [
      `Phone Numbers & Emails`,
      `Premier Agent Advertising`,
      `NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited`,
      `Divorce Leads Unlimited`,
      `Probate Leads Unlimited`,
      `FSBO (For Sale By Owner) Leads Unlimited`,
      `Expired Leads Unlimited`,
      `Canceled Leads Unlimited`,
      `Withdrawn Leads Unlimited`,
      `Deal Analyzer Access`,
      `Unlimited BPO Tech Training Center Access`,
      `BPO Report Ordering Page`,
      `Luxury Investor Website`,
      `Investor Log (Investor List Available for Purchase)`,
      `MDA (Million Dollar Agent) Business Program`,
      `20% Referral Fee Required from BPO Homes Pre-Qualified Leads`,
      `Go High Level CRM Pro Edge Included`,
      `Guaranteed Pre-Qualified Lead Per Month`,
      `Life Insurance Licensing Fee Add On`,
    ],
  },
  {
    title: "Premier Agent Ultra (SET UP FEE NOT INCLUDED $99)",
    benefits: [
      `Phone Numbers & Emails`,
      `Premier Agent Advertising`,
      `NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited`,
      `Divorce Leads Unlimited`,
      `Probate Leads Unlimited`,
      `FSBO (For Sale By Owner) Leads Unlimited`,
      `Expired Leads Unlimited`,
      `Canceled Leads Unlimited`,
      `Withdrawn Leads Unlimited`,
      `Deal Analyzer Access`,
      `Unlimited BPO Tech Training Center Access`,
      `BPO Report Ordering Page`,
      `Luxury Investor Website`,
      `Investor Log (Investor List Available for Purchase)`,
      `MDA (Million Dollar Agent) Business Program`,
      `10% Referral Fee Required from BPO Homes Pre-Qualified Leads`,
      `Go High Level CRM Pro Edge Included`,
      `Guaranteed Pre-Qualified Lead Per Month`,
      `Includes Real Estate Virtual Assistant Service`,
      `Life Insurance Licensing Fee Add On`,
    ],
  },
];

const schedule = [
  {
    name: "Email Campaigns",
    starter_days_to_add: 30,
    pro_days_to_add: 30,
    elite_days_to_add: 30,
  },
  {
    name: "MMS Campaigns",
    starter_days_to_add: 30,
    pro_days_to_add: 30,
    elite_days_to_add: 30,
  },
  // {
  // 	name: 'Facebook Ads',
  // 	starter_days_to_add: 30,
  // 	pro_days_to_add: 30,
  // 	elite_days_to_add: 30,
  // },
  {
    name: "Post Card Mailers",
    starter_days_to_add: 180,
    pro_days_to_add: 90,
    elite_days_to_add: 30,
  },
  {
    name: "Seller Calling",
    starter_days_to_add: 180,
    pro_days_to_add: 180,
    elite_days_to_add: 90,
  },
];

//array of time zones in usa

const timeZones = [
  {
    value: "Eastern Time Zone",
    label: "Eastern Time Zone",
  },
  {
    value: "Hawaii Time Zone",
    label: "Hawaii Time Zone",
  },
  {
    value: "Mountain Time Zone",
    label: "Mountain Time Zone",
  },
  {
    value: "Central Time Zone",
    label: "Central Time Zone",
  },
  {
    value: "Atlantic Time Zone",
    label: "Atlantic Time Zone",
  },
  {
    value: "Pacific Time Zone",
    label: "Pacific Time Zone",
  },
  {
    value: "Alaska Time Zone",
    label: "Alaska Time Zone",
  },
];

const specialties = [
  "",
  "Buyer Agent",
  "Listing Agent",
  "Relocation",
  "Short Sale",
  "Foreclosure",
  "Consulting",
  "Other",
];
const languages = [
  "",
  "English",
  "Spanish",
  "French",
  "German",
  "Mandarin",
  "Cantonese",
  "Arabic",
  "Hindi",
  "Polish",
  "Italian",
  "Thai",
  "Korean",
  "Greek",
];

const headerImages = [
  {
    img: "https://bpooperationsmain.s3.eu-west-2.amazonaws.com/template_images/headerImage1.jpg",
    title: "Header 1",
  },
  {
    img: "https://bpooperationsmain.s3.eu-west-2.amazonaws.com/template_images/headerImage2.jpg",
    title: "Header 2",
  },
  {
    img: "https://bpooperationsmain.s3.eu-west-2.amazonaws.com/template_images/headerImage3.jpg",
    title: "Header 3",
  },
  {
    img: "https://bpooperationsmain.s3.eu-west-2.amazonaws.com/template_images/headerImage4.jpg",
    title: "Header 4",
  },
  {
    img: "https://bpooperationsmain.s3.eu-west-2.amazonaws.com/template_images/headerImage5.jpg",
    title: "Header 5",
  },
];

const ratingOptions = [
  { label: "Local Knowledge", value: "local_knowledge" },
  { label: "Process Expertise", value: "process_expertise" },
  { label: "Responsiveness", value: "responsiveness" },
  { label: "Negotiation Skills", value: "negotiation_skills" },
];

const mapPolygonStyles = { fillColor: "#FFAA01", strokeColor: "#1378A5" };
const exteriorList = [
  "Street View",
  "Front House",
  "Left Side",
  "Right Side",
  "Backyard",
  "Other Exterior photos",
];
const interiorList = [
  "Kitchen",
  "Bathroom(s)",
  "Floorings",
  "Other Interior photos",
];

const additionalFields = [
  {
    label: "Home Style",
    amount: "home_style_value",
    feedback: "home_style_feedback",
    tooltip:
      "This indicates if the this style of home is up with the current desirable Market Trends for the area",
  },
  {
    label: "Feng Shui",
    amount: "feng_shui_value",
    feedback: "feng_shui_feedback",
    tooltip:
      "This indicates if the floor plan or flow of the home is desirable",
  },
  {
    label: "Proximity to Amenities or Neutral",
    amount: "proximity_to_amenities_value",
    feedback: "proximity_to_amenities_feedback",
    tooltip:
      "Property Near Parks, Shopping, Walking Trails, Dinning, Cul De Sac",
  },
  {
    label: "Proximity Neighborhood Negatives & Nuisances or Neutral",
    amount: "proximity_neighborhood_negative_value",
    feedback: "proximity_neighborhood_negative_feedback",
    tooltip: "Freeways, Busy Streets, Far Away from shopping & Dining",
  },
];
const property_condition_options = [
  "Very Poor",
  "Poor",
  "Average",
  "Above Average",
  "Excellent",
];

const investorTypes = [
  {
    label: "Flips",
    name: "flips",
  },
  {
    label: "Development",
    name: "development",
  },
  {
    label: "Home additions",
    name: "home-additions",
  },
  {
    label: "Rentals",
    name: "rentals",
  },
];

const mainWithOptions = [
  {
    name: "Electrical",
    options: [
      "EV chargers",
      "Electrical wiring",
      "Emergency electrical services",
      "Landscape lighting",
      "Electrical repairs",
      "Rewiring",
      "Surge protector",
      "Ceiling fan installation",
      "Chandelier installation",
      "Custom lighting",
      "Electrical Construction",
      "Generator installation",
      "Outlet and switch repair",
      "Electrical inspections",
      "Remodels",
      "Safety inspections",
      "Appliance circuits",
      "Electrical upgrades",
      "Home automation",
      "Recessed lighting",
      "Smoke detectors",
      "Aluminum wiring",
      "Electrical maintenance",
      "Electrical panels",
    ],
  },
  {
    name: "Plumbing",
    options: [
      "Drain cleaning and unclogging",
      "Water heater maintenance",
      "Sewer line inspections and repairs",
      "Mold remediation",
      "Garbage disposal repairs and replacement",
      "Pipe restoration and excavation",
      "Water damage cleanup",
      "Leak repairs",
      "Sewer Line Install",
      "Piping",
      "Septics",
      "Well",
      "Wells",
      "Potable Water Systems",
      "Public Sewer Systems",
      "Buy Water Heater",
      "Water Heater Repair",
      "Water Heater Install",
      "Tankless Water Heater",
      "Tankless Water Heater Install",
      "Water Heater Replacement",
      "Tankless Water Heater Repair",
      "PVC",
      "ABS",
      "Sewer Line",
      "Copper Plumbing",
      "Galvanized Plumbing Repairs",
      "Galvanized Plumbing",
    ],
  },
  {
    name: "Roofing",
    options: [
      "Roof replacement",
      "Leak repair",
      "Roof patching",
      "Gutter installation and repair",
      "Roof inspections",
      "Flashing fabrication and installation",
      "New roof installation",
      "Moss Growth Removal",
      "Roof Install",
      "Tar & Gravel Roof",
      "Torch Down Roof",
      "Foam Roof",
      "Composition Roof",
      "Composition Asphalt Shingle Roof",
      "Asphalt Shingle Roof",
      "Gable Roof",
      "Flat Roof",
      "Gambrel Roof",
      "Mansard Roof",
      "Hip Roof",
      "Metal Roofing",
      "Slate Roof",
      "Butterfly Roof",
      "Concrete Tiles",
      "Shed Roof",
      "Dutch Gable Roof",
      "Wood Shake Roof",
      "Shake Roof",
      "Dormer",
      "Dormers",
      "Rubber Roofing",
      "Shingles",
      "Membrane Roofing",
      "Saltbox",
      "Gutter Install",
      "Sheathing Install",
      "Roof Sheathing Install",
      "Spanish Tiles Roof",
      "Spanish Roof Tiles",
      "Spanish Tiles",
      "Skylights",
      "Skylight Install",
      "Moss Growth",
      "Moss Removal",
    ],
  },
  {
    name: "Insulation",
    options: [
      "Wall insulation",
      "Spray foam",
      "Cellulose insulation",
      "Fiberglass batt insulation",
      "Glass wool",
      "Mineral wool",
      "Rigid board insulation",
      "BIBS insulation",
      "Floors",
      "Air sealing",
      "Blown In Insulation",
      "Blown Insulation",
      "Closed Cell Spray Foam: R-6 to R-7",
      "Foam Board: R-4.5 to R-5",
      "RetroFoam Injection Foam: R-4.6 to R-5",
      "Open Cell Spray Foam: R-3.6 to R-3.9",
      "Cellulose (Loose-Fill): R-3.1 to R-3.8",
      "Fiberglass (Batts): R-2.9 to R3.8",
      "Fiberglass (Loose-Fill): R-2.2 to R-2.9",
      "R-1 Insulation",
      "R-1.5",
      "R-2",
      "R-2.5",
      "R-3",
      "R-3.5",
      "R-4",
      "R-4.5",
      "R-4.6",
      "R-5.5",
      "R-6",
      "R-7",
    ],
  },
  {
    name: "Flooring",
    options: [
      "Tile",
      "Laminate flooring",
      "Carpet",
      "Hardwood flooring",
      "Vinyl Plank Flooring",
      "Engineered wood",
      "Linoleum",
      "Stone",
      "Cork",
      "Hardwood",
      "Vinyl",
      "Bamboo flooring",
      "Concrete",
      "Bamboo",
      "Cantera flooring",
      "Bathroom flooring",
      "Hybrid flooring",
      "Parquet flooring",
      "Resin flooring",
      "Carpet tiles",
      "Concrete floors",
      "Other types of flooring",
      "Flooring Install",
      "Flooring Removal",
      "Flooring Damage",
      "Flooring Repair",
    ],
  },
  {
    name: "Handyman",
    options: [
      "Plumbing",
      "Carpentry",
      "Painting",
      "Electricity",
      "Furniture assembly",
      "Pressure washing",
      "Deck repairs",
      "Gutter cleaning",
      "Smart home upgrades",
      "Tiling",
      "Fixture Replacement",
      "Repairs",
      "Fix fences",
      "Floor improvements",
      "HVAC",
      "Landscaping",
      "Art hanging",
      "Babyproofing",
      "Drywall repair",
      "Door adjustments",
      "Drywall",
      "Skylight installation",
      "Window coverings",
      "Door repair",
      "Miscellaneous Repairs",
      "Home Improvement",
    ],
  },
  {
    name: "Landscaping",
    options: [
      "Lawn mower",
      "Mulch",
      "Landscape design",
      "Weed control",
      "Fertilization",
      "Lawn aerator",
      "Pruning",
      "Mowing",
      "Pruning shrubs",
      "Snow removal",
      "Bush trimming",
      "Irrigation",
      "Dethatching",
      "Edging",
      "Planting",
      "Gutter cleaning",
      "Hedging",
      "Leaf removal",
      "Lawn returfing",
      "Trimming",
      "Lawn bed maintenance",
      "Pest control",
      "Clean up",
      "Sod Installation",
      "Grass Installation",
      "Flower Planting",
      "Plant Planting",
      "Tree Planting",
      "Tree Removal",
      "Irrigation startup or shutdown services",
    ],
  },
  {
    name: "General Contractor",
    options: [
      "Remodeling",
      "Remodel Kitchen",
      "Remodel Baths",
      "Framing",
      "Electrical",
      "Plumbing",
      "Roofing",
      "Flooring",
      "Tiles",
      "Landscaping",
      "Concrete",
      "Electrical Contactor",
      "Roofing Contractor",
      "Commercial Contractor",
      "GC",
      "General Contractor",
      "Residential Contractor",
      "New Construction",
      "Rebuild",
      "Demolition",
      "Demo",
      "Gut",
      "Insulation",
      "Foundation",
      "Structural Engineering",
    ],
  },
  {
    name: "Garage Door",
    options: [
      "Garage Door Repair",
      "Garage Door Install",
      "Garage Door",
      "Buy Garage Door",
      "Purchase Garage Door",
    ],
  },

  {
    name: "HVAC",
    options: [
      "Heat",
      "Air",
      "Duct Installation",
      "Air Duct Install",
      "Heating Duct Install",
      "Duct Install",
      "HVAC",
      "Buy AC Unit",
      "Buy Furnace",
    ],
  },
  {
    name: "Home Staging",
    options: ["Staging", "Stage my House", "Stager"],
  },
  {
    name: "Painting",
    options: ["Painting", "Painter"],
  },
  {
    name: "Home Design",
    options: ["Homes Design", "Homes Designer"],
  },
  {
    name: "Fire Safety",
    options: [
      "Inspections",
      "Maintenance",
      "Fire Sprinkler System Design",
      "Fire Sprinkler",
      "Maintenance Inspections",
      "Fire Sprinkler Maintenance",
      "Fire Suppression",
      "FM 200 Inspections",
      "Kitchen Suppression",
      "Commercial Sprinklers",
      "Residential Sprinklers",
      "Residential Fire Sprinkler Inspections",
      "Commercial Fire Sprinkler Inspections",
      "Fire Sprinkler Install",
      "Fire Sprinkler Plumbing",
      "Fire Sprinkler Monitoring",
      "Fire Sprinkler System Repair",
    ],
  },
  {
    name: "House/ Home Cleaning",
    options: [
      "House Cleaning",
      "Kitchen Cleaning",
      "Bedroom Cleaning",
      "Bathroom Cleaning",
      "Dusting",
    ],
  },
  {
    name: "Kitchen Counter Suppliers",
    options: [
      "Solid Surface Countertops",
      "Butcher Block Countertops",
      "Laminate Countertops",
      "Soapstone",
      "Ceramic Tile",
      "Stainless Steel",
      "Kitchen Counters",
      "Granite Counter Tops",
      "Quartz Counter Tops",
      "Marble Counter Tops",
      "Kitchen Cabinets",
      "Custom Kitchen Cabinets",
    ],
  },
  {
    name: "Tile Suppliers",
    options: [
      "Bathroom Tile",
      "Flooring & Carpet",
      "Kitchen Flooring",
      "Material",
      "Ceramic",
      "Porcelain",
      "Stone",
      "Stores",
      "Home Depot",
      "Lowe's",
      "Walmart",
      "Square Tiles",
      "Rectangle Tiles",
      "Rectangular Tiles",
      "Hexagon Tiles",
      "Herringbone",
      "Matte",
      "Glossy",
      "Glazed",
      "Polished",
      "Large Format Tiles",
      "Standard Format Tiles",
      "Mosaic",
      "Features",
      "Outdoor Tiles",
      "Tiles With Water Protection",
      "Accent Tiles",
      "GREENGUARD Certified Tiles",
      "Pressed Tiles",
      "Straight Edge Tiles",
      "Rectified Tiles",
      "Contemporary Tiles",
      "Modern Tiles",
      "Farmhouse Tiles",
      "Classic Tiles",
      "Ivy Hill Tile",
      "Somertile",
      "MSI",
      "Daltile",
      "Marazzi Tile",
      "Emser Tile",
      "TrafficMASTER",
      "Bedrosians",
    ],
  },
  {
    name: "Window Suppliers",
    options: [
      "Awning windows",
      "Casement windows",
      "Double hung windows",
      "Single hung windows",
      "Sliding windows",
      "Picture windows",
      "Bay windows",
      "Bow windows",
      "Skylights",
      "Hopper windows",
      "Transom windows",
      "Garden windows",
      "Slider windows",
      "Fixed windows",
      "Glass block windows",
      "Jalousie windows",
      "Storm windows",
      "Egress windows",
      "Ingress windows",
      "Shaped windows",
      "Arched windows",
      "Round windows",
      "Casement",
      "Dormer window",
      "Single hung",
    ],
  },
  {
    name: "Architect",
    options: [
      "Residential Plans",
      "Commercial Plans",
      "Home Design",
      "Building Design",
      "Architectural Engineering",
      "Structural Engineering",
      "Plan Design",
      "Residential Architect",
      "Commercial Architect",
    ],
  },
  {
    name: "Mold Abatement",
    options: ["Mold Removal"],
  },
  {
    name: "Junk Removal",
    options: [
      "Junk Removal",
      "Junk Hauling",
      "Demolition",
      "Demo",
      "Gut",
      "Property Gutting",
    ],
  },
  {
    name: "Asbestos Abatement",
    options: ["Asbestos Removal"],
  },
  {
    name: "Mortgage Brokers",
    options: ["Lending", "Mortgage Rates", "Loan"],
  },
  {
    name: "Homes Insurance",
    options: ["Asbestos Removal"],
  },
];

export const claimListingForm = [
  {
    label: "Is there an Offer Date set for Seller to Review Offers?",
    question: "Is there an Offer Date set for Seller to Review Offers?",
    name: "offer_date_available",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    validation: {
      required: "This field is required",
    },
  },
  {
    label: "Offer Date",
    question: "Offer Date",
    name: "review_offer_date",
    type: "date",
    conditional: true,
    dependency: "offer_date_available",
    depValue: "yes",
  },
  {
    label: "Authorize BPO Homes to display an Offer Date Countdown ",
    question:
      "Do you Authorize BPOHomes to display an Offer Date Countdown on BPOHomes.com for any potential Buyers and or the General Public to View?",
    name: "give_authorization",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    // validation: {
    //   required: "This field is required",
    // },
  },
  {
    label:
      "Will the Seller View Offers at the time any such Offers are Presented?",
    question:
      "Will the Seller View Offers at the time any such Offers are Presented?",
    name: "seller_view_offer",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    validation: {
      required: "This field is required",
    },
  },
  {
    label:
      "Do you Authorize BPO Homes to display the time the Offers will be reviewed?",
    question:
      "Do you Authorize BPOHomes to display an Offer Review Status on BPOHomes.com for any potential Buyers and or the General Public to View?",
    name: "display_offer_review_status",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    // validation: {
    //   required: "This field is required",
    // },
  },
  {
    label: "How many Hours/Days after Buyer offers are presented",
    question:
      "How many Hours or Days after Buyer offers are presented does Seller Request to review such Buyer offers?",
    name: "request_review_duration",
    type: "text_select",
    numberType: true,
    fullWidth: true,
    placeholder: "Hours/Days",
    // validation: {
    //   required: "This field is required",
    // },
    selectList: [
      { name: "Hours", value: "hours" },
      { name: "Days", value: "days" },
    ],
    selectListKey: "hours_days",
    selectListDefVal: "hours",
  },
  {
    label: "Would you Like the Days or Hours for Seller Response Displayed?",
    question:
      "Would you Like the Days or Hours for Seller Response Displayed for Potential Buyers & or General Public Viewing?",
    name: "display_duration_response",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    // validation: {
    //   required: "This field is required",
    // },
  },
  {
    label:
      "Is the Seller or Listing Broker offering to the Buyer Agent or Buyer Broker a commission?",
    question:
      "Is the Seller or Listing Broker offering to the Buyer Agent or Buyer Broker a concession?",
    name: "commission_available",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    validation: {
      required: "This field is required",
    },
  },
  {
    label:
      "Display the Commission Rate Offered by Seller or Listing Broker payable",
    question:
      "Would you Like BPO HOMES to Email the Commission Rate Offered by the Seller or Seller’’s Broker to Buyer Broker and/or Buyer Brokers Agents upon Buyer Agent or Buyer Broker request?",
    name: "email_commission_rate",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    // validation: {
    //   required: "This field is required",
    // },
  },
  {
    label: "Who will pay the Buyer Broker?",
    question: "Who will pay the Buyer Broker?",
    name: "pay_buyer_broker",
    type: "select",
    list: [
      {
        name: "Seller",
        value: "seller",
      },
      {
        name: "Seller Brokerage",
        value: "sellerbrokerage",
      },
    ],
    // validation: {
    //   required: "This field is required",
    // },
  },
  // {
  //   label:
  //     "What is the Total Buyer Broker commission rate being offered for Buyer Broker Representation of Buyer? Select Commission Percentage Rate of Total Purchase price or Manually Enter the Fixed Amount.",
  //   name: "total_commision",
  //   type: "select",
  //   list: [
  //     {
  //       name: "10%",
  //       value: "10",
  //     },
  //     {
  //       name: "20%",
  //       value: "20",
  //     },
  //     {
  //       name: "Enter Manually",
  //       value: "manual",
  //     },
  //   ],
  //   // validation: {
  //   //   required: "This field is required",
  //   // },
  // },
  {
    label: "Commission Percentage Rate or Fixed Amount",
    question:
      "What is the Total Buyer Broker commission rate being offered for Buyer Broker Representation of Buyer? Select Commission Percentage Rate of Total Purchase price or Manually Enter the Fixed Amount.",
    name: "total_commision_rate",
    type: "text_select",
    numberType: true,
    fullWidth: true,
    placeholder: "Enter Percentage or Fixed Amount",
    // validation: {
    //   required: "This field is required",
    // },
    selectList: [
      { name: "Percentage (%)", value: "percentage" },
      { name: "Fixed Amount($)", value: "amount" },
    ],
    selectListKey: "amount_percentage",
    selectListDefVal: "percentage",
    // conditional: true,
    // dependency: "total_commision",
    // depValue: "manual",
  },
  {
    label: "Is there a Lock Box at the Property?",
    question: "Is there a Lock Box at the Property?",
    name: "lock_box_available",
    type: "select",
    list: [
      {
        name: "Yes",
        value: "yes",
      },
      {
        name: "No",
        value: "no",
      },
    ],
    validation: {
      required: "This field is required",
    },
  },
  {
    label: "What Type of Lock Box",
    question: "What is the type of Lock Box at the Property?",
    name: "lock_box_type",
    type: "select",
    list: [
      {
        name: "Supra",
        value: "supra",
      },
      {
        name: "Combo",
        value: "combo",
      },
      {
        name: "Other",
        value: "other",
      },
    ],
    // validation: {
    //   required: "This field is required",
    // },
  },
  {
    label: "Enter other Lock Box type",
    question: "Enter other Lock Box type",
    name: "other_lock_box_type",
    type: "text",
    placeholder: "Enter other type",
    conditional: true,
    dependency: "lock_box_type",
    depValue: "other",
  },
  {
    label: "Where is the Lock Box Location?",
    question: "Where is the Lock Box Location?",
    name: "lock_box_location",
    type: "text",
    placeholder: "Lock Location",
  },
  {
    label: "Private Notes for Brokers & Agents",
    question: "Provide Private Notes for Brokers & Agent to View",
    name: "private_notes",
    type: "textarea",
    placeholder: "Hint Text",
    // validation: {
    //   required: "This field is required",
    // },
  },
];

export const sampleBuyerRequests = [
  {
    id: "req-001",
    listingId: "04150",
    propertyImage: "",
    propertyAddress: "123 Main Street, Anytown, CA 94150",
    buyerName: "John Smith",
    buyerEmail: "john.smith@example.com",
    buyerPhone: "(555) 123-4567",
    requestDate: "2025-04-25T14:30:00",
    message:
      "I'm interested in scheduling a viewing for this property this weekend. Is it possible to see it on Saturday afternoon? I'm particularly interested in the kitchen renovation and would like to know more about the appliances.",
    status: "new",
  },
  {
    id: "req-002",
    listingId: "04151",
    propertyImage: "",
    propertyAddress: "456 Oak Avenue, Somewhere, CA 94151",
    buyerName: "Sarah Johnson",
    buyerEmail: "sarah.j@example.com",
    buyerPhone: "(555) 987-6543",
    requestDate: "2025-04-24T09:15:00",
    message:
      "Hello, I'd like to get more information about this property. Specifically, I'm wondering about the HOA fees and what they cover. Also, are there any planned assessments in the near future?",
    status: "pending",
  },
  {
    id: "req-003",
    listingId: "04152",
    propertyImage: "",
    propertyAddress: "789 Pine Lane, Elsewhere, CA 94152",
    buyerName: "Michael Brown",
    buyerEmail: "michael.b@example.com",
    buyerPhone: "(555) 456-7890",
    requestDate: "2025-04-23T16:45:00",
    message:
      "I'm interested in making an offer on this property. Before I do, I'd like to know if there have been any other offers and if there are any known issues with the property that weren't disclosed in the listing.",
    status: "responded",
  },
  {
    id: "req-004",
    listingId: "04153",
    propertyImage: "",
    propertyAddress: "101 Cedar Court, Nowhere, CA 94153",
    buyerName: "Emily Davis",
    buyerEmail: "emily.d@example.com",
    buyerPhone: "(555) 234-5678",
    requestDate: "2025-04-22T11:00:00",
    message:
      "I noticed this property has been on the market for a while. Is the seller open to negotiation on the price? Also, I'd like to know more about the neighborhood, particularly regarding schools and public transportation.",
    status: "closed",
  },
];

// Sample data
export const sampleRequests = [
  {
    id: "req-001",
    listingId: "04150",
    propertyImage: "",
    propertyAddress: "123 Main Street, Anytown, CA 94150",
    listingAgent: {
      id: "agent-001",
      name: "Robert Williams",
      email: "robert.w@realestate.com",
      phone: "(555) 123-4567",
      company: "Premier Real Estate",
    },
    requestDate: "2025-04-25T14:30:00",
    message:
      "I have a client who is very interested in this property. Could you provide more details about the recent renovations mentioned in the listing? Also, is the seller flexible on the closing date?",
    status: "new",
  },
  {
    id: "req-002",
    listingId: "04151",
    propertyImage: "",
    propertyAddress: "456 Oak Avenue, Somewhere, CA 94151",
    listingAgent: {
      id: "agent-002",
      name: "Jennifer Martinez",
      email: "jennifer.m@homesellers.com",
      phone: "(555) 987-6543",
      company: "Home Sellers Group",
    },
    requestDate: "2025-04-24T09:15:00",
    message:
      "My clients are relocating from out of state and are interested in this property. They'd like to know more about the neighborhood, particularly regarding schools and public transportation. Also, would it be possible to arrange a virtual tour in the next few days?",
    status: "pending",
  },
  {
    id: "req-003",
    listingId: "04152",
    propertyImage: "",
    propertyAddress: "789 Pine Lane, Elsewhere, CA 94152",
    listingAgent: {
      id: "agent-003",
      name: "David Thompson",
      email: "david.t@luxuryestates.com",
      phone: "(555) 456-7890",
      company: "Luxury Estates",
    },
    requestDate: "2025-04-23T16:45:00",
    message:
      "I have clients who are very interested in making an offer on this property. Before we proceed, they'd like to know if there are any other offers currently on the table and if there are any known issues with the property that weren't disclosed in the listing.",
    status: "responded",
    response: {
      responseDate: "2025-04-24T10:30:00",
      message:
        "Thank you for your interest in this property. We currently have two other offers under consideration. The seller has disclosed a minor plumbing issue in the guest bathroom that has been repaired, but no other issues. Please let me know if your clients would like to schedule a viewing or if they have any other questions.",
      hasAttachments: false,
    },
  },
  {
    id: "req-004",
    listingId: "04153",
    propertyImage: "",
    propertyAddress: "101 Cedar Court, Nowhere, CA 94153",
    listingAgent: {
      id: "agent-004",
      name: "Lisa Johnson",
      email: "lisa.j@cityhomes.com",
      phone: "(555) 234-5678",
      company: "City Homes Realty",
    },
    requestDate: "2025-04-22T11:00:00",
    message:
      "My client is interested in this property but has concerns about the HOA fees. Could you provide a breakdown of what these fees cover? Also, are there any planned special assessments in the near future?",
    status: "responded",
    response: {
      responseDate: "2025-04-23T14:15:00",
      message:
        "I've attached the detailed HOA information packet which breaks down all the fees and what they cover. The monthly fee of $350 includes water, trash, building insurance, common area maintenance, and reserves. There are no special assessments planned for the next 12 months according to the most recent HOA meeting minutes, which I've also attached for your reference.",
      hasAttachments: true,
    },
  },
  {
    id: "req-005",
    listingId: "04154",
    propertyImage: "",
    propertyAddress: "202 Maple Drive, Somewhere Else, CA 94154",
    listingAgent: {
      id: "agent-005",
      name: "Michael Chen",
      email: "michael.c@propertypros.com",
      phone: "(555) 345-6789",
      company: "Property Pros",
    },
    requestDate: "2025-04-20T15:30:00",
    message:
      "My clients are interested in this property but would like to know if the seller would consider a lease-to-own arrangement. They're also curious about the age of the roof and HVAC system.",
    status: "closed",
    response: {
      responseDate: "2025-04-21T09:45:00",
      message:
        "I've discussed your inquiry with the seller, and unfortunately, they are not interested in a lease-to-own arrangement at this time. They are looking for a traditional sale. Regarding your other questions, the roof was replaced 5 years ago and has a 30-year warranty. The HVAC system is original to the home (15 years old) but has been well-maintained with service records available for review.",
      hasAttachments: false,
    },
  },
];

export const reportStatusThemeColor = {
  Incomplete: "brand.grey.700",
  Pending: "brand.blue.700",
  Complete: "primary.success.700",
  Total: "brand.purple.700",
};

export const newListingSchema = {
  id: Date.now() + Math.floor(Math.random() * 1_000_000),
  address: "",
  sales_price: "",
  price_per_gross_living_area: 0,
  // days_on_market: "",
  // sale_date: "",
  description: "",
  lot_size: "",
  condition: null,
  num_bedrooms: "",
  num_bathrooms: "",
  gross_living_area: "",
  home_style_value: "",
  garage: 0,
  home_style_feedback: "",
  feng_shui_value: "",
  feng_shui_feedback: "",
  proximity_to_amenities_value: "",
  proximity_to_amenities_feedback: "",
  proximity_to_negatives_value: "",
  proximity_neighborhood_negative_feedback: "",
  lot_size_difference_amount: 0,
  garage_difference_amount: 0,
  livable_square_footage_difference_amount: 0,
  images: [],
};

export const bpoReportSchema = {
  clients_physical_address: "",
  brokerage: "",
  firm: "",
  agent: "",
  name: "",
  number: "",
  phone: "",
  completed_by: "",
  current_market_conditions: "Decreased", //Increased, Decreased, Slow, Stable
  neighborhood_price_lower: "",
  neighborhood_price_upper: "",
  marketing_time: 0,
  subject_impact: "over",
  unit_type: "Single Family Detached", //[ Single Family Detached,Single Family Attached Condominium, Town House ]
  market_price_change_percentage: 0,
  time_change: 0,
  market_price_change_months: 0,
  current_market_value: "",
  current_suggested_list_price: "",
  repaired_market_value: "",
  repaired_suggested_list_price: "",
  num_of_active_listings: "",
  active_listings_period: "",
  num_of_sold_listings: "",
  sold_listings_time: "",
  exterior_photos: [],
  interior_photos: [],
  final_summary: "",
  is_property_remodelled: false,
  comparable_closed_listings: [newListingSchema],
  comparable_active_listings: [newListingSchema],
};

export const allLeadsHeaders = [
  { label: "Name", key: "name", maxWidth: 200 },
  { label: "Type", key: "type" },
  { label: "Location", key: "location", maxWidth: 150 },
  { label: "Company", key: "company" },
  { label: "Capital/Experience", key: "capital_experience", maxWidth: 150 },
  { label: "Focus/Speciality", key: "focus_speciality", maxWidth: 150 },
  { label: "Actions", key: "fe" },
];
export const investorHeaders = [
  { label: "Name", key: "name", maxWidth: 200 },
  { label: "Liquid Capital", key: "liquid_capital" },
  { label: "Focus Areas", key: "areas_of_focus", maxWidth: 200 },
  { label: "Type of Investment", key: "type_of_investments" },
  { label: "Experience (Yrs)", key: "years_of_investing" },
  { label: "Phone Number", key: "phone_number" },
  { label: "Actions", key: "fe" },
];
export const agentHeaders = [
  { label: "Name", key: "name", maxWidth: 200 },
  { label: "Location", key: "location", maxWidth: 150 },
  { label: "Company", key: "company", maxWidth: 10 },
  { label: "Experience", key: "experience", maxWidth: 100 },
  { label: "Phone Number", key: "phone_number", maxWidth: 150 },
  { label: "Actions", key: "fe" },
];
export const areaOfFocus = [
  {
    label: "Alaska",
    value: "AK",
  },
  {
    label: "Alabama",
    value: "AL",
  },
  {
    label: "Arkansas",
    value: "AR",
  },
  {
    label: "Arizona",
    value: "AZ",
  },
  {
    label: "California",
    value: "CA",
  },
  {
    label: "Colorado",
    value: "CO",
  },
  {
    label: "Connecticut",
    value: "CT",
  },
  {
    label: "Delaware",
    value: "DE",
  },
  {
    label: "Florida",
    value: "FL",
  },
  {
    label: "Georgia",
    value: "GA",
  },
  {
    label: "Hawaii",
    value: "HI",
  },
  {
    label: "Iowa",
    value: "IA",
  },
  {
    label: "Idaho",
    value: "ID",
  },
  {
    label: "Illinois",
    value: "IL",
  },
  {
    label: "Indiana",
    value: "IN",
  },
  {
    label: "Kansas",
    value: "KS",
  },
  {
    label: "Kentucky",
    value: "KY",
  },
  {
    label: "Louisiana",
    value: "LA",
  },
  {
    label: "Massachusetts",
    value: "MA",
  },
  {
    label: "Maryland",
    value: "MD",
  },
  {
    label: "Maine",
    value: "ME",
  },
  {
    label: "Michigan",
    value: "MI",
  },
  {
    label: "Minnesota",
    value: "MN",
  },
  {
    label: "Missouri",
    value: "MO",
  },
  {
    label: "Mississippi",
    value: "MS",
  },
  {
    label: "Montana",
    value: "MT",
  },
  {
    label: "North Carolina",
    value: "NC",
  },
  {
    label: "North Dakota",
    value: "ND",
  },
  {
    label: "Nebraska",
    value: "NE",
  },
  {
    label: "New Hampshire",
    value: "NH",
  },
  {
    label: "New Jersey",
    value: "NJ",
  },
  {
    label: "New Mexico",
    value: "NM",
  },
  {
    label: "Nevada",
    value: "NV",
  },
  {
    label: "New York",
    value: "NY",
  },
  {
    label: "Ohio",
    value: "OH",
  },
  {
    label: "Oklahoma",
    value: "OK",
  },
  {
    label: "Oregon",
    value: "OR",
  },
  {
    label: "Pennsylvania",
    value: "PA",
  },
  {
    label: "Rhode Island",
    value: "RI",
  },
  {
    label: "South Carolina",
    value: "SC",
  },
  {
    label: "South Dakota",
    value: "SD",
  },
  {
    label: "Tennessee",
    value: "TN",
  },
  {
    label: "Texas",
    value: "TX",
  },
  {
    label: "Utah",
    value: "UT",
  },
  {
    label: "Virginia",
    value: "VA",
  },
  {
    label: "Vermont",
    value: "VT",
  },
  {
    label: "Washington",
    value: "WA",
  },
  {
    label: "Wisconsin",
    value: "WI",
  },
  {
    label: "West Virginia",
    value: "WV",
  },
  {
    label: "Wyoming",
    value: "WY",
  },
];

export const specializationOptions = [
  "Residential Sales",
  "Commercial Sales",
  "Property Management",
  "Investment Properties",
  "Luxury Homes",
  "First-Time Buyers",
];
export const investmentStrategies = [
  "Fix & Flip",
  "Buy & Hold",
  "Wholesale",
  "Development",
  "Commercial",
  "Hard Money Lending",
  "Waterfront Properties & Marine Real Estate",
];

export const propertyTypesOptions = [
  "Single Family",
  "Multifamily",
  "Condos/Townhomes",
  "Commercial",
  "Land",
  "Luxury Properties",
];

export const capitalRangeOptions = [
  {
    label: "Under $100K",
    min: 0,
    max: 100000,
  },
  {
    label: "$100K - $500K",
    min: 100000,
    max: 500000,
  },
  {
    label: "$500K - $1M",
    min: 500000,
    max: 1000000,
  },
  {
    label: "$1M - $5M",
    min: 1000000,
    max: 5000000,
  },
  {
    label: "$5M - $10M",
    min: 5000000,
    max: 10000000,
  },
  {
    label: "Over $10M",
    min: 10000000,
    max: Number.MAX_SAFE_INTEGER,
  },
];

export {
  mainWithOptions,
  sellList,
  buyList,
  analyticsList,
  professionalOptions,
  states,
  timeZones,
  URL,
  statesShort,
  farmPackages,
  schedule,
  specialties,
  languages,
  headerImages,
  ratingOptions,
  mapPolygonStyles,
  additionalFields,
  exteriorList,
  interiorList,
  property_condition_options,
  investorTypes,
  closed_listing_conditions,
};
